export var Log = window.console;
